import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';

import { calculationService } from '../utils/api/calculationService';

import { useCalculationsStore } from '../store/calculations';

export function useDeleteCalculation(getCalculationId: () => number) {
  const visible = ref(false);
  const isLoading = ref(false);

  const calculationStore = useCalculationsStore();

  const toast = useToast();

  async function deleteCalculation() {
    const calculationId = getCalculationId();

    try {
      isLoading.value = true;
      await calculationService.destroyCalculation(calculationId);

      calculationStore.removeCalculationById(calculationId);
    } catch (error) {
      console.log(error);

      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas usuwania kalkulacji',
        life: 3000,
      });
    } finally {
      visible.value = false;
      isLoading.value = false;
    }
  }

  return {
    visible,
    isLoading,
    deleteCalculation,
  };
}
